module.exports = __webpack_public_path__ + "static/img/Image-1.53a3dc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/story/Image-1.png
// module id = so6X
// module chunks = 0